import React, { useState, useEffect } from "react";
import {
  Card,
  Box,
  Typography,
  Grid,
  Button,
} from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import LoaderCon from "../../Common/loader/containers/loader_cont";
import Snackbar1 from "../../Common/snackbar/components/snackbar";
import { ChevronLeft } from "lucide-react";
export default function Viewcars(props) {
  const navigate = useNavigate();
  const { id } = useParams();
  useEffect(() => {
    props.viewOldCarById(props.login.token, props.login.user_id, id);
    props.viewOverviewById(props.login.token, props.login.user_id, id);
    props.viewSpecificationById(props.login.token, props.login.user_id, id);
    props.viewFeturesById(props.login.token, props.login.user_id, id);

  }, [props.login.token, props.login.user_id, id]);


  const car = props.client.viewoldCarById;
  const overview = props.client.viewOverviewById;
  const specs = props.client.viewSpecificationById;
  const feat = props.client.viewFetureById;

  const InfoSection = ({ title, data, source }) => (
    <Card
      sx={{
        mb: 3,
        backgroundColor: "#ffffff",
        borderRadius: "10px",
        boxShadow: "0 4px 10px rgba(0,0,0,0.06)",
        border: "1px solid #e5e5e5",
      }}
    >
      {/* Header */}
      <Box
        sx={{
          backgroundColor: "#cf2230",
          color: "#fff",
          textAlign: "center",
          px: 1.5,
          py: 0.5,
          borderTopLeftRadius: "10px",
          borderTopRightRadius: "10px",
        }}
      >
        <Typography
          variant="h6"
          sx={{ fontWeight: 700, letterSpacing: "0.3px" }}
        >
          {title}
        </Typography>
      </Box>

      {/* Two-Column Grid */}
      <Grid
        container
        spacing={0}
        sx={{ p: 2 }}
      >
        {data?.map((item, idx) => {
          const value = source?.[item.value]
            ? `${source[item.value]} ${item.suffix || ""}`
            : "--";

          return (
            <Grid
              item
              xs={12}
              md={6}
              key={idx}
              sx={{
                p: 1.5,
                display: "flex",
                justifyContent: "space-between",
                gap: 2
              }}
            >
              <Typography
                sx={{
                  fontWeight: 600,
                  color: "#000",
                  fontSize: "15px",
                }}
              >
                {item.label} :
              </Typography>

              <Typography
                sx={{
                  fontWeight: 500,
                  color: value === "--" ? "#777" : "#cf2230",
                  fontSize: "15px",
                  textAlign: "right",
                  maxWidth: "55%",
                }}
              >
                {value}
              </Typography>
            </Grid>
          );
        })}
      </Grid>
    </Card>
  );

  const sections = {
    basicInfoFields: [
      { label: 'Brand Name', value: 'brand' },
      { label: 'Car Name', value: 'carName' },
      { label: 'Fuel Type', value: 'fuelType' },
      { label: 'Car Type', value: 'carType' },
      { label: 'Price', value: 'price' },
      { label: 'Discounted Price', value: 'discountedPrice' },
      { label: 'Kilometer', value: 'kilometer' }
    ],

    // Overview fields
    overviewFields: [
      { label: 'Registration Year', value: 'registerationYear' },
      { label: 'Manufacturing Year', value: 'manufacturingYear' },
      { label: 'No. of Owners', value: 'owners' },
      { label: 'Transmission', value: 'transmission' },
      { label: 'Color', value: 'color' },
      { label: 'Insurance', value: 'insurance' },
      { label: 'Registration Type', value: 'registerationType' }
    ],

    // Specifications - Engine & Transmission
    engineTransmissionFields: [
      { label: 'Engine(in cc)', value: 'engine', unit: 'cc' },
      { label: 'Max Power (bhp@rpm)', value: 'maxPower', unit: 'rpm' },
      { label: 'Max Torque (Nm@rpm)', value: 'maxTorque', unit: 'rpm' },
      { label: 'Mileage (ARAI)', value: 'mileage', unit: 'kmpl' },
      { label: 'Drive Train', value: 'driveTrain', unit: '' }
    ],

    // Specifications - Dimensions & Weight
    dimensionsWeightFields: [
      { label: 'Length', value: 'length', unit: 'mm' },
      { label: 'Width', value: 'width', unit: 'mm' },
      { label: 'Height', value: 'height', unit: 'mm' },
      { label: 'Wheelbase', value: 'wheelbase', unit: 'mm' },
      { label: 'Ground Clearance', value: 'groundClearance', unit: 'mm' },
      { label: 'Kerb Weight', value: 'kerbWeight', unit: 'kg' }
    ],

    // Specifications - Capacity
    capacityFields: [
      { label: 'Doors', value: 'doors', unit: 'Doors' },
      { label: 'Seating Capacity', value: 'seatingCapacity', unit: 'Person' },
      { label: 'No of Rows', value: 'rows', unit: 'Rows' },
      { label: 'Bootspace', value: 'bootspace', unit: 'litres' },
      { label: 'Fuel Tank Capacity', value: 'fuelTankCapacity', unit: 'litres' }
    ],

    // Specifications - Suspensions, Brakes, Steering & Tyres
    suspensionBrakesFields: [
      { label: 'Front Suspension', value: 'frontSuspension', unit: '' },
      { label: 'Rear Suspension', value: 'rearSuspension', unit: '' },
      { label: 'Front Brake Type', value: 'frontbrakeType', unit: '' },
      { label: 'Rear Brake Type', value: 'rearBrakeType', unit: '' },
      { label: 'Min Turning Radius', value: 'minTurningRadius', unit: 'metres' },
      { label: 'Steering Type', value: 'steeringType', unit: '' },
      { label: 'Wheels', value: 'wheels', unit: '' },
      { label: 'Spare Wheel', value: 'spareWheel', unit: '' },
      { label: 'Front Tyres', value: 'frontTyres', unit: '' },
      { label: 'Rear Tyres', value: 'rearTyres', unit: '' }
    ],

    // Features - Safety
    safetyFeatures: [
      { label: 'Airbags', value: 'airbag', isText: true },
      { label: 'Tyre Pressure Monitoring System (TPMS)', value: 'tyrePresssure' },
      { label: 'Child Seat Anchor Points', value: 'childSeatAnchorPoints' },
      { label: 'Seat Belt Warning', value: 'seatBeltWarning' }
    ],

    // Features - Braking & Traction
    brakingTractionFeatures: [
      { label: 'Anti-Lock Braking System (ABS)', value: 'abs' },
      { label: 'Electronic Brake-force Distribution (EBD)', value: 'ebd' },
      { label: 'Brake Assist (BA)', value: 'ba' },
      { label: 'Electronic Stability Program (ESP)', value: 'esp' },
      { label: 'Four-Wheel-Drive', value: 'fourWheel' },
      { label: 'Hill Hold Control', value: 'hillHoldControl' },
      { label: 'Traction Control System (TC/TCS)', value: 'tcs' },
      { label: 'Hill Descent Control', value: 'hillDescentControl' }
    ],

    // Features - Locks & Security
    locksSecurityFeatures: [
      { label: 'Engine Immobiliser', value: 'engineImmobiliser' },
      { label: 'Central Locking', value: 'centeralLocking' },
      { label: 'Speed Sensing Door Lock', value: 'speedSensingDoorLock' },
      { label: 'Child Safety Lock', value: 'childSafetyLock' }
    ],

    // Features - Comfort & Convenience
    comfortConvenienceFeatures: [
      { label: 'Air Conditioner', value: 'ac' },
      { label: 'Front AC', value: 'frontac' },
      { label: 'Rear AC', value: 'rearac' },
      { label: 'Heater', value: 'heater' },
      { label: 'Vanity Mirrors on Sun Visors', value: 'vanityMirror' },
      { label: 'Anti-glare Mirrors', value: 'antiglareMirror' },
      { label: 'Parking Assist', value: 'parkingAssist' },
      { label: 'Parking Sensors', value: 'parkingSensor' },
      { label: 'Cruise Control', value: 'cruisecontrol' },
      { label: 'Headlight and Ignition On Reminder', value: 'headlightIgnition' },
      { label: 'Keyless Start/ Button Start', value: 'keylessstart' },
      { label: 'Steering Height Adjustment', value: 'steeringAdjustment' },
      { label: '12V Power Outlets', value: 'power' }
    ],

    // Features - Mobile App
    mobileAppFeatures: [
      { label: 'Apple Carplay', value: 'applecarplay' },
      { label: 'Android Auto', value: 'androidauto' }
    ],

    // Features - Seats & Upholstery
    seatsUpholsteryFeatures: [
      { label: 'Seat Upholstery', value: 'seatUpholestry' },
      { label: 'Driver Side Seat Adjustment', value: 'drivesideAdjust' },
      { label: 'Leather-wrapped Steering Wheel', value: 'leatherWrapped' },
      { label: 'Driver Armrest', value: 'driverArmrest' },
      { label: 'Folding Rear Seat', value: 'foldingRearSeat' },
      { label: 'Split Rear Seat', value: 'splitRearSeat' },
      { label: 'Split Third Row Seat', value: 'splitThirdRowSeat' },
      { label: 'Front Seatback Pockets', value: 'frontSeatbackPockets' },
      { label: 'Headrests', value: 'headrests' }
    ],

    // Features - Storage
    storageFeatures: [
      { label: 'Cup Holders', value: 'cupholders' },
      { label: 'Driver Armrest Storage', value: 'driverArmrestStorage' },
      { label: 'Cooled Glovebox', value: 'cooledGloveBox' },
      { label: 'Sunglass Holder', value: 'sunGlassHolder' },
      { label: 'Third Row Cup Holders', value: 'thirdRowCupHolder' }
    ],

    // Features - Doors, Windows, Mirrors & Wipers
    doorsWindowsFeatures: [
      { label: 'Body Color ORVM', value: 'orvm' },
      { label: 'Power Windows', value: 'powerWindow' },
      { label: 'One Touch Down', value: 'oneTouchDown' },
      { label: 'One Touch Up', value: 'oneTouchUp' },
      { label: 'Electric Adjustable ORVMs', value: 'adjustableOrvm' },
      { label: 'Body Color Exterior Door Handles', value: 'exteriorDoorHandle' },
      { label: 'Chrome Exterior Door Handles', value: 'chromeexteriorDoorHandle' },
      { label: 'Door Pockets', value: 'doorPockets' },
      { label: 'Bootlid Opener', value: 'bootlidOpener' }
    ],

    // Features - Exterior
    exteriorFeatures: [
      { label: 'Sunroof / Moonroof', value: 'sunroof' },
      { label: 'Roof-mounted Antenna', value: 'roofMountedAntenna' },
      { label: 'Body-coloured Bumpers', value: 'bodyColouredBumpers' },
      { label: 'Chrome Finish Exhaust Pipe', value: 'chromeFinish' }
    ],

    // Features - Lighting
    lightingFeatures: [
      { label: 'Projector Headlights', value: 'projectorheadlight' },
      { label: 'Automatic Headlamps', value: 'autoheadlamps' },
      { label: 'Follow Me Home Headlamps', value: 'homeheadlamps' },
      { label: 'DRL', value: 'drl' },
      { label: 'LED Taillights', value: 'tailights' },
      { label: 'Cabin Lamps', value: 'cabinLamps' },
      { label: 'Light on Vanity Mirrors', value: 'lightonVanityMirror' },
      { label: 'Rear Reading Lamp', value: 'rearreadinglamp' },
      { label: 'Glovebox Lamp', value: 'gloveBoxlamp' },
      { label: 'Headlight Height Adjuster', value: 'headlightHeightAdjuster' }
    ],

    // Features - Instrumentation
    instrumentationFeatures: [
      { label: 'Trip Meter', value: 'tripMeter' },
      { label: 'Average Fuel Consumption', value: 'averageFuelConsumption' },
      { label: 'Distance to Empty', value: 'distancetoEmpty' },
      { label: 'Clock', value: 'clock' },
      { label: 'Low Fuel Level Warning', value: 'lowFuelWarning' },
      { label: 'Door Ajar Warning', value: 'doorAjarWarning' },
      { label: 'Adjustable Cluster Brightness', value: 'adjustableCluster' },
      { label: 'Gear Indicator', value: 'gearIndicator' },
      { label: 'Shift Indicator', value: 'shiftIndicator' },
      { label: 'Tachometer', value: 'tachometer' }
    ],

    // Features - Entertainment
    entertainmentFeatures: [
      { label: 'Integrated (in-dash) Music System', value: 'musicSystem' },
      { label: 'Speakers', value: 'speaker' },
      { label: 'Steering-mounted controls', value: 'steeringmountedctrls' },
      { label: 'Voice Command', value: 'voiceCommand' },
      { label: 'GPS Navigation System', value: 'gps' },
      { label: 'Bluetooth Compatibility', value: 'bluetooth' },
      { label: 'AUX Compatibility', value: 'aux' },
      { label: 'AM/FM Radio', value: 'radio' },
      { label: 'USB Compatibility', value: 'usb' },
      { label: 'Head Unit Size', value: 'headUnitSize' }
    ],
  };

  return (
    <Box sx={{ p: 2 }}>
      {/* --- Car Images --- */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 3,
          gap: 2,
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          {/* Back Button */}
          <ChevronLeft
            onClick={() => navigate(-1)}
            sx={{
              fontWeight: 600,
              textTransform: "none",
              color: "#cf2230",
              fontSize: '20px',
              cursor: 'pointer',
            }} />

          {/* Title */}
          <Typography
            variant="h5"
            sx={{
              fontWeight: 700,
              textAlign: "center",
              flexGrow: 1,
            }}
          >
            {car.brand} - {car.carName} - {car.carType}
          </Typography>
        </div>

        {/* Image List */}
        <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
          {car?.image?.map((img, i) => (
            <Box
              component="img"
              src={img}
              alt=""
              sx={{
                width: 250,
                height: 100,
                objectFit: "cover",
                borderRadius: "8px",
                transition: "transform 0.3s, box-shadow 0.3s",
                cursor: "pointer",
                transformOrigin: "top right",   // ⭐ key change
                "&:hover": {
                  transform: "scale(1.8)",
                  zIndex: 20,
                  position: "relative",
                  boxShadow: "0 8px 20px rgba(0,0,0,0.3)",
                },
              }}
            />

          ))}
        </Box>
      </Box>


      <InfoSection title="BASIC INFORMATION" data={sections?.basicInfoFields} source={car} />
      <InfoSection title="OVERVIEW" data={sections?.overviewFields} source={overview} />
      <InfoSection title="SPECIFICATIONS" data={sections?.engineTransmissionFields} source={specs} />
      <InfoSection title="DIMENSIONS & WEIGHT" data={sections?.dimensionsWeightFields} source={specs} />
      <InfoSection title="CAPACITY" data={sections?.capacityFields} source={specs} />
      <InfoSection title="SUSPENSIONS, BRAKES, STEERING & TYRES" data={sections?.suspensionBrakesFields} source={specs} />
      <InfoSection title="SAFETY FEATURES" data={sections?.safetyFeatures} source={feat} />
      <InfoSection title="BRAKING & TRACTION FEATURES" data={sections?.brakingTractionFeatures} source={feat} />
      <InfoSection title="LOCKS & SECURITY FEATURES" data={sections?.locksSecurityFeatures} source={feat} />
      <InfoSection title="COMFORT & CONVENIENCE FEATURES" data={sections?.comfortConvenienceFeatures} source={feat} />
      <InfoSection title="MOBILE APP FEATURES" data={sections?.mobileAppFeatures} source={feat} />

      <LoaderCon />
      <Snackbar1
        open={props.snackbar.response_received}
        onClose={props.close_snack_bar}
        message={props.snackbar.message}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      />
    </Box>
  )
};
